import React from 'react';
import * as S from '../SimilarHotelsLoader/SimilarHotelsLoader.styles';

const SimilarHotelsLoader = () => (
  <S.SimilarHotelsLoaderWrapDiv>
    <S.SimilarHotelsLoaderInnerWrapDiv>
      <S.SimilarHotelsLoaderHeaderDiv></S.SimilarHotelsLoaderHeaderDiv>
      <S.SimilarHotelsImageDiv></S.SimilarHotelsImageDiv>
      <S.HotelsImageTitleDiv></S.HotelsImageTitleDiv>
      <S.HotelsSubTitleDiv></S.HotelsSubTitleDiv>
      <S.HotelsSubTitleDiv></S.HotelsSubTitleDiv>
      <S.HotelsImageTitleDiv></S.HotelsImageTitleDiv>
      <S.HotelsImageTitleDiv></S.HotelsImageTitleDiv>
      <S.HotelsSubTitleWrapDiv>
        <S.HotelsSubTitleDiv></S.HotelsSubTitleDiv>
        <S.HotelsSubTitleDiv></S.HotelsSubTitleDiv>
        <S.HotelsSubTitleDiv></S.HotelsSubTitleDiv>
      </S.HotelsSubTitleWrapDiv>
      <S.HotelsSmallTextDiv></S.HotelsSmallTextDiv>
      <S.HotelsSmallTextDiv></S.HotelsSmallTextDiv>
      <S.HotelsSmallTextDiv></S.HotelsSmallTextDiv>
    </S.SimilarHotelsLoaderInnerWrapDiv>
  </S.SimilarHotelsLoaderWrapDiv>
);

export default SimilarHotelsLoader;
